import SimpleBar from 'simplebar'

angular.module("mobileMenu", [])
    .controller("mobileMenu", ['$scope',
        function ($scope) {

            $scope.isOpen = false;

            $scope.toggleMobile = function () {
                $scope.isOpen = !$scope.isOpen;
            };
        }
    ]);

$("#submenu").on('shown.bs.collapse', function () {
    new SimpleBar(document.getElementById('simplebar'), {
        autoHide: false
    });
})


// WEBPACK FOOTER //
// ./src/js/imports/mobileMenu.js